module.exports = __webpack_public_path__ + "img/logo-footer.7d0e9150.svg";